import { useEffect } from "react";

interface EmailModalProps {
  isOpen: any;
  onClose: any;
  demoData: any;
}



function XIcon() {
  return (
    <svg
      className="w-5 h-5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );
}

export default function BugModal({
  isOpen,
  onClose,
  demoData,
}: EmailModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("coverflow_hidden_scoll_bdy");
      return () => {
        document.body.classList.remove("coverflow_hidden_scoll_bdy");
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  console.log(demoData,'demoData')

  const result = demoData?.find((i: any) => i.id == isOpen);

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="bg-white rounded-md shadow-2xl w-full max-w-[991px]">
        <div className="flex flex-col rounded-md">
          {/* Header */}
          <div className="flex items-start justify-between px-6 pt-5 pb-0 border-b border-gray-100">
            <div>
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest tracking-widest-icon mb-1 flex items-center gap-1.5">
                DEMO MESSAGE
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 cta-red transition mt-0.5 ml-4 flex-shrink-0 pt-1"
              aria-label="Close"
            >
              <XIcon />
            </button>
          </div>

          {/* Sender Row */}
          <div className=" max-h-[60vh] overflow-y-auto rounded-md px-6">
            {/* Body */}
            <div className="py-5 text-sm text-gray-700 leading-relaxed space-y-4">
              <div>{result?.message}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
